/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiKeyResponse
 */
export interface ApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    apiKey: string;
}

/**
 * Check if a given object implements the ApiKeyResponse interface.
 */
export function instanceOfApiKeyResponse(value: object): value is ApiKeyResponse {
    if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
    return true;
}

export function ApiKeyResponseFromJSON(json: any): ApiKeyResponse {
    return ApiKeyResponseFromJSONTyped(json, false);
}

export function ApiKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'apiKey': json['apiKey'],
    };
}

export function ApiKeyResponseToJSON(json: any): ApiKeyResponse {
    return ApiKeyResponseToJSONTyped(json, false);
}

export function ApiKeyResponseToJSONTyped(value?: ApiKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiKey': value['apiKey'],
    };
}

